import { i } from "./main23.js";
var o = i;
function n(r) {
  if (typeof r == "string" || o(r))
    return r;
  var t = r + "";
  return t == "0" && 1 / r == -1 / 0 ? "-0" : t;
}
var y = n;
export {
  y as _
};
